import { defineMessages } from "react-intl";

export const publicationMessages = defineMessages({
  published: {
    id: "ys0jH2",
    defaultMessage: "Published",
    description: "channel publication status",
  },
  notPublished: {
    id: "ClKKID",
    defaultMessage: "Not published",
    description: "channel publication status",
  },
  willBecomePublishedOn: {
    id: "hTLCC2",
    defaultMessage: "Will become published on {date}",
    description: "channel publication date",
  },
  willBecomeAvailableOn: {
    id: "znbVYT",
    defaultMessage: "Will become available on {date}",
    description: "product available for purchase date",
  },
  availableForPurchase: {
    id: "P/oGtb",
    defaultMessage: "Available for purchase",
    description: "product availability",
  },
  unavailableForPurchase: {
    id: "Y9lv8z",
    defaultMessage: "Unavailable for purchase",
    description: "product unavailability",
  },
  publishedSince: {
    id: "kYYbrv",
    defaultMessage: "Published since {date}",
    description: "channel publication date",
  },
  setAvailabilityDate: {
    id: "YFQBs1",
    defaultMessage: "Set availability date",
    description: "product availability date label",
  },
});
